"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const countries = [
    "alb",
    "asm",
    "and",
    "aia",
    "atg",
    "arg",
    "arm",
    "abw",
    "aus",
    "aut",
    "aze",
    "bhs",
    "bhr",
    "blr",
    "bel",
    "blz",
    "ben",
    "bmu",
    "btn",
    "bes",
    "bih",
    "bwa",
    "bvt",
    "bra",
    "iot",
    "brn",
    "bgr",
    "bfa",
    "cmr",
    "can",
    "cpv",
    "cym",
    "tcd",
    "cxr",
    "cck",
    "com",
    "cok",
    "civ",
    "hrv",
    "cuw",
    "cyp",
    "cze",
    "dnk",
    "dji",
    "dma",
    "dom",
    "egy",
    "slv",
    "gnq",
    "eri",
    "est",
    "eth",
    "flk",
    "fro",
    "fji",
    "fin",
    "fra",
    "atf",
    "gab",
    "gmb",
    "geo",
    "deu",
    "gha",
    "gib",
    "grc",
    "grl",
    "grd",
    "glp",
    "gum",
    "ggy",
    "gin",
    "guy",
    "hmd",
    "vat",
    "hkg",
    "hun",
    "ind",
    "idn",
    "irl",
    "imn",
    "isr",
    "ita",
    "jam",
    "jpn",
    "jey",
    "jor",
    "kaz",
    "ken",
    "kir",
    "kor",
    "kwt",
    "lao",
    "lva",
    "lso",
    "lie",
    "ltu",
    "lux",
    "mac",
    "mkd",
    "mdg",
    "mwi",
    "mys",
    "mdv",
    "mlt",
    "mhl",
    "mtq",
    "mrt",
    "mus",
    "myt",
    "mex",
    "fsm",
    "mda",
    "mco",
    "mng",
    "mne",
    "msr",
    "moz",
    "nam",
    "nru",
    "nld",
    "ncl",
    "nzl",
    "ner",
    "nga",
    "niu",
    "nfk",
    "mnp",
    "nor",
    "omn",
    "plw",
    "pry",
    "phl",
    "pcn",
    "pol",
    "prt",
    "pri",
    "qat",
    "reu",
    "rou",
    "rus",
    "rwa",
    "blm",
    "shn",
    "kna",
    "lca",
    "maf",
    "spm",
    "vct",
    "wsm",
    "smr",
    "stp",
    "sen",
    "srb",
    "syc",
    "sgp",
    "sxm",
    "svk",
    "svn",
    "slb",
    "zaf",
    "sgs",
    "esp",
    "lka",
    "sur",
    "sjm",
    "swz",
    "swe",
    "che",
    "twn",
    "tjk",
    "tza",
    "tha",
    "tls",
    "tgo",
    "tkl",
    "ton",
    "tto",
    "tur",
    "tkm",
    "tca",
    "tuv",
    "uga",
    "ukr",
    "are",
    "gbr",
    "usa",
    "umi",
    "ury",
    "uzb",
    "vut",
    "vnm",
    "vgb",
    "vir",
    "wlf",
    "esh",
    "zmb",
];
exports.default = countries;
//# sourceMappingURL=countries.js.map